import React from "react";
import "../style/aboutus_homepage.css";
import isaLogo from "../parm_assets/about_us/ic_isa.jpg"; // replace with your local image
import safeTreeLogo from "../parm_assets/parm_logo_2.png"; // replace with your local image
import infoIcon from "../parm_assets/tree_icons.png"; // replace with your path
import { Image, ImageKitProvider } from '@imagekit/react';

const workerImg = "https://ik.imagekit.io/axiomhives/parm_assets/about_us/WhatsApp%20Image%202026-02-05%20at%209.48.07%20AM.jpeg";

const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        {/* Left Section */}
        <div className="about-left">
          <div className="image-grid">
            <img src={workerImg} alt="Tree Worker" className="main-img" />
            <div className="badge">
              <h2>21</h2>
              <p>Years Of<br />Association</p>
            </div>
            <img src={isaLogo} alt="ISA Logo" className="isa-img" />
            <img 
              src="https://ik.imagekit.io/axiomhives/parm_assets/Logo_-_PARM__pokok_bulat_.jpg-removebg-preview.png" 
              alt="Safe Tree Logo" 
              className="safe-img" />
          </div>
        </div>

        {/* Right Section */}
        <div className="about-right">
          <p className="about-tag">
            <img src={infoIcon} alt="icon" className="about-icon" />
            ABOUT US
            </p>
          <h2 className="about-title">
            Pioneer in Malaysia <br /> Tropical Arboriculture
          </h2>
          <p className="about-desc">
            Persatuan Arborist Malaysia (PArM) is a non-profit organization that
            serves as an umbrella body for arboriculture practitioners involved
            in maintenance and management of urban forest trees. Our members are
            from multiple backgrounds which include professional members and
            students passionate about the importance of tree care in the urban
            landscape. Continuous education programs and expertise topics are
            promoted and shared through experienced and specialist speakers from
            ISA Certified Arborist, academicians and researchers from the Forest
            Research Institute of Malaysia and higher-level institutions in
            Malaysia. PArM stands for sustainable urban forest landscape.
          </p>
          <a href="/about" className="read-more-link">
          <button className="read-btn">
            Read More <span className="arrow">→</span>
          </button>
        </a>

          <div className="vision-mission">
            <div className="vm-card">
              <div className="vm-header">
                <div className="circle"></div>
                <h3>VISION</h3>
              </div>
              <p>Pioneer in Malaysia Tropical Arboriculture.</p>
            </div>

            <div className="vm-card">
              <div className="vm-header">
                <div className="circle"></div>
                <h3>MISSION</h3>
              </div>
              <p>
                To uplift professionalism in the field of arboriculture and to
                inculcate public awareness regarding tree benefits and functions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
